import { usePuzzelChat } from '../hooks/Puzzel/usePuzzelChat';
import { usePuzzelEUWA } from '../hooks/Puzzel/usePuzzel';

interface ChatProps {
  isEnabled: boolean;
}

export const Chat = ({ isEnabled }: ChatProps) => {
  const puzzelEUWA = usePuzzelEUWA();
  usePuzzelChat(puzzelEUWA, isEnabled);
  return null;
};
